import { forwardRef, memo, type Ref } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';

interface IAssistedHygieneFieldProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
] as const;

const Component = (
  { value, onChange, isOpen, onToggle }: IAssistedHygieneFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const displayValue =
    value === true ? 'Yes' : value === false ? 'No' : undefined;

  return (
    <div ref={ref}>
      <FormDropdown
        label="Assisted Hygiene"
        value={displayValue}
        isOpen={isOpen}
        onToggle={onToggle}
        testId="assisted-hygiene-field"
      >
        {OPTIONS.map((option) => (
          <DropdownOption
            key={option.label}
            isSelected={value === option.value}
            onSelect={() => {
              onChange?.(option.value);
              onToggle();
            }}
            testId={`assisted-hygiene-option-${option.label.toLowerCase()}`}
          >
            {option.label}
          </DropdownOption>
        ))}
      </FormDropdown>
    </div>
  );
};

export const AssistedHygieneField = memo(forwardRef(Component));
